// Main component exports
export { TicketSelect } from "./dynamic";

// Individual component exports for direct importing
export { ClientSelectWithModal } from "./ClientSelectWithModal";
export { TicketSelectWithModal } from "./TicketSelectWithModal";
export { DealSelectWithModal } from "./DealSelectWithModal";
export { TemplateSelect } from "./TemplateSelect";

// Contact-related select components
export { ContactStatusSelect, ContractTypeSelect, IndustrySelect, SourceSelect } from "./contact";

// Boolean select components
export { ActiveStatusSelect, BooleanActiveStatusSelect } from "./boolean";

// Utility exports
export { useModalManager } from "./hooks/useModalManager";
export type { UseModalManagerProps, UseModalManagerReturn } from "./hooks/useModalManager";
